// ~/composables/usePhotoSwipe.ts

import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

export function usePhotoSwipe(gallerySelector: string) {
    const galleryElementClass = '.pswp'; 
    const init = () => {
        const lightbox = new PhotoSwipeLightbox({
            gallery: gallerySelector,
            children: 'a',
            pswpModule: () => import('photoswipe'),
            bgOpacity: 0.8,
            showHideOpacity: true,
            paddingFn: (viewportSize) => ({
                top: viewportSize.x < 767 ? 20 : 0,
                bottom: viewportSize.x < 767 ? 20 : 0,
                left: 20,
                right: 20,
            }),
        });

        // Register custom UI element for dot pagination
        lightbox.on('uiRegister', () => {
        lightbox.pswp?.ui.registerElement({
            name: 'bulletsIndicator',
            className: 'pswp__bullets-indicator',
            appendTo: 'wrapper',
            onInit: (el, pswp) => {
            const bullets = [];
            let bullet;
            let prevIndex = -1;

            for (let i = 0; i < pswp.getNumItems(); i++) {
                bullet = document.createElement('div');
                bullet.className = 'pswp__bullet';
                bullet.onclick = (e) => {
                pswp.goTo(bullets.indexOf(e.target));
                };
                el.appendChild(bullet);
                bullets.push(bullet);
            }

            pswp.on('change', () => {
                if (prevIndex >= 0) {
                bullets[prevIndex].classList.remove('pswp__bullet--active');
                }
                bullets[pswp.currIndex].classList.add('pswp__bullet--active');
                prevIndex = pswp.currIndex;
            });
            },
        });
        });

        lightbox.init();
    };
    const initWithButtons  = () => {
        const lightbox = new PhotoSwipeLightbox({
            gallery: gallerySelector,
            children: 'a',
            pswpModule: () => import('photoswipe'),
            bgOpacity: 0.8,
            spacing: 0.5,
            loop: false, 
            allowPanToNext: false,
            showHideOpacity: true,
            zoom: true,
            counter: false,
            arrowKeys: false,
            arrowPrev: false,
            arrowNext: false,
            paddingFn: (viewportSize) => {
                return {
                  top: viewportSize.x < 720 ? 20 : 40,
                  bottom: viewportSize.x < 720 ? 20 : 40,
                  left: 0,
                  right: 0
                };
              }
        })

            // Register custom UI elements for zoom and fullscreen
            lightbox.on('uiRegister', () => {
                // Add fullscreen button
                lightbox.pswp?.ui.registerElement({
                name: 'fullscreenButton',
                order: 9, 
                html: '<button class="pswp__button pswp__button--fullscreen" style="color: #fff;" title="Fullscreen">⛶</button>',
                onClick: (el, pswpInstance) => {
                        // if (!pswpInstance || !pswpInstance.element) {
                        //     console.error('PhotoSwipe instance or element is not available');
                        //     return;
                        // }
                        // const galleryElement = pswpInstance.element;
                        const galleryElement = document.querySelector(galleryElementClass);
                
                        if (document.fullscreenElement) {
                            document.exitFullscreen();
                        } else {
                            galleryElement.requestFullscreen().catch((err) => {
                            console.error('Fullscreen request failed:', err);
                            });
                        }
                    },
                });
            });
        // Ensure the element is initialized before adding buttons
        lightbox.on('afterInit', () => {
            console.log('PhotoSwipe initialized. Element available:', lightbox.pswp?.element);
        });

        lightbox.init()
    }

  return { init, initWithButtons };
}
